import { useState } from "react";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import AboutSection from "@/components/AboutSection";
import ServicesSection from "@/components/ServicesSection";
import BenefitsSection from "@/components/BenefitsSection";
import FAQSection from "@/components/FAQSection";
import CTASection from "@/components/CTASection";
import Footer from "@/components/Footer";
import ReservationModal from "@/components/ReservationModal";

const Home = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <div className="min-h-screen bg-[#0a0a0a] grain-overlay">
      <Navbar onReservar={() => setShowModal(true)} />
      <HeroSection onReservar={() => setShowModal(true)} />
      <AboutSection />
      <ServicesSection />
      <BenefitsSection onReservar={() => setShowModal(true)} />
      <FAQSection />
      <CTASection onReservar={() => setShowModal(true)} />
      <Footer />
      <ReservationModal open={showModal} onClose={() => setShowModal(false)} />
    </div>
  );
};

export default Home;
